import { api } from '@/core/api/request'
import { logger } from '@/core/app/logger'
import { CampaignGetResponseSchema, PopupGetResponseSchema } from '@/schemas/v2'
import type { CampaignGetResponse, PopupGetResponse } from '@/schemas/v2'
import { MasterUpdateCheckResponseSchema } from '@/schemas/v2/master'
import type { MasterUpdateCheckResponse } from '@/schemas/v2/master'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

export async function fetchCampaign(options?: FetchOptions): Promise<CampaignGetResponse> {
  const url = `${BASE}/api/v2/campaign`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return CampaignGetResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function fetchPopups(options?: FetchOptions): Promise<PopupGetResponse> {
  const url = `${BASE}/api/v2/popups`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return PopupGetResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function fetchMasterUpdateCheck(options?: FetchOptions): Promise<MasterUpdateCheckResponse> {
  const url = `${BASE}/api/v2/master/update/check`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return MasterUpdateCheckResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
